<template lang="pug">
    div
        model-form(
            v-bind="formProps"
            v-model="formData"
            no-buttons
            )
</template>

<script>
//-
import { ModelForm } from '@/components/reusable_components/next'
import MdlPurchaseOrders from '@/models/Purchase/PchPurchaseOrder'
import { PurchaseOrderFields, detailHeaders } from './purchaseOrder'
import { mapActions } from 'vuex'
import includes from '@/services/api/purchaseOrders/purchaseOrdersIncludes'
//-
export default {
    name: 'show-purchase-order',
    props: {},
    data: function() {
        return {
            formData: {},
            fields: PurchaseOrderFields,
        }
    },
    computed: {
        //-
        formProps() {
            return {
                fields: this.fields,
                editable: false,
                switchEdit: false,
                readOnly: true,
            }
        },
    },
    methods: {
        //-
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        getPurchaseOrder: function() {
            MdlPurchaseOrders.include(includes)
                .find(this.$route.params.pchId)
                .then(this.fillFields)
                .catch(e => console.log('error: ', e))
        },

        /**
         *
         */
        fillFields: function(model) {
            model = this.setFieldsByModel(model)
            this.formData = model
        },

        /**
         *
         */
        fullName: function(hr_employee) {
            return `${hr_employee.names} ${hr_employee.last_name1} ${hr_employee.last_name2}`
        },

        /**
         *
         */
        setFieldsByModel: function(model) {
            let obj = { ...model }
            obj.g_originator_user_name = this.fullName(
                model.g_originator_user.hr_employee
            )
            obj.wh_warehouse_name = model.wh_warehouse.name
            obj.pch_provider_name = model.pch_provider.alias_name
            obj.pch_provider_branch_offices_name =
                model.pch_provider_branch_offices.address
            obj.pch_payment_condition_name = model.pch_payment_condition.type
            obj.pch_detail_purchase_orders = model.pch_detail_purchase_orders.map(
                r => {
                    r.wh_product_name = r.wh_product.name
                    return r
                }
            )
            return obj
        },
    },
    components: { 'model-form': ModelForm },
    created: function() {
        this.setTitleTopBar(`Orden de compra n°${this.$route.params.pchId}`)
        this.getPurchaseOrder()
    },
}
</script>

<style lang="scss"></style>
